export class AutoCompleteEnvironment {
  public static getName = () => 'benzinga-autocomplete';
  public static getEnvironment = (env: Record<string, string>) => ({
    fundsUrl: new URL(env.fundsUrl ?? 'https://api.benzinga.com'),
    symbolsKey: env.symbolsKey ?? '',
    symbolsUrl: new URL(env.symbolsUrl ?? 'https://data-api-pro.benzinga.com/rest/'),
  });
}
